import { useSelector as useReduxSelector } from 'react-redux'
import type { RootState } from '../configure-store.js'

export const useSelector = <T>(
  callback: (state: RootState) => T,
  equalityFn?: ((left: T, right: T) => boolean) | undefined
) => useReduxSelector(callback, equalityFn)
